import { put, call, fork, takeMaybe } from 'redux-saga/effects'
import { deleteTagService } from 'src/api/tag'
import { deleteTagSuccess } from 'src/reducers/tag/action'
import { TAG_DELETE } from 'src/reducers/tag/type'
import generalSaga from '../general'
import { operationSuccess, operationFail } from 'src/reducers/operation/action'

function* deleteTagFlow(payload) {
  try {
    const { id, callback } = payload
    yield call(deleteTagService, id)
    yield put(deleteTagSuccess(id))
    yield put(operationSuccess())
    if (callback) callback()
  } catch (error) {
    yield put(operationFail(error))
  }
}

export default function* deleteTagWatcher() {
  while (true) {
    const action = yield takeMaybe(TAG_DELETE)
    const { payload } = action

    yield fork(generalSaga, deleteTagFlow, payload)
  }
}
